<div class="Confirmacion"><h1>Confirmación</h1>
<p>Al cancelar su suscripción, el sistema dejará de cobrar a los clientes y, en caso de existir, los portales de afiliación dejarán de vincular a nuevos clientes. ¿Está seguro que desea desactivar?</p>
<div class="action">
  <button class="cancelar" (click)="onDismiss()">Cancelar</button>
  <button class="aceptar" [mat-dialog-close]="true">Aceptar</button>
</div>
</div>
